<div class="position-absolute" *ngIf="loading">
    <app-loading *ngIf="loading"></app-loading>
</div>

<div
    class="inner-container bg-white cart-page"
    *ngIf="favoritesList?.length && !loading"
>
    <ng-container>
        <embryo-PageTitle
            *ngIf="lang == 'en'"
            heading="Here’s what’s in your favorites"
            subHeading=""
        >
        </embryo-PageTitle>
        <embryo-PageTitle
            *ngIf="lang == 'ar'"
            heading="مكونات قائمة المفضلة"
            subHeading=""
        >
        </embryo-PageTitle>
    </ng-container>

    <div class="container section-gap">
        <div class="cart-wrapper">
            <div class="cart-shop-list mb-5 text-center card-shadow">
                <div class="position-relative">
                    <div
                        fxLayout="row wrap"
                        fxLayoutAlign="start center"
                        class="cart-item"
                        *ngFor="let favorite of favoritesList; let i = index"
                    >
                        <div
                            fxFlex.xs="100"
                            fxFlex.sm="100"
                            fxFlex.md="10"
                            fxFlex.lg="20"
                            fxFlex.xl="20"
                            class="cart-product-image"
                        >
                            <div class="cart-item-thumb">
                              <!-- [queryParams]="{ variant: favorite?.id }" -->
                                <a
                                    [routerLink]="[
                                        '/' +
                                            lang +
                                            '/' +
                                            favorite.slug
                                    ]"
                                    class="p-link"
                                    style="cursor: pointer; outline: none"
                                >
                                    <img  loading="lazy" 
                                        width="626"
                                        height="800"
                                        onError="this.src='./assets/images/placeholder200.jpg';"
                                        default="./assets/images/placeholder200.jpg"
                                        [src]="favorite?.image"
                                           alt="cart image"
                                    />
                                </a>
                                <div
                                    class="chip-container d-flex flex-column"
                                    [class.chip-ar]="lang == 'ar'"
                                >
                                    <mat-chip
                                        *ngIf="
                                            favorite?.discount_price !== null &&
                                            favorite?.price
                                        "
                                        class="chip-item my-1"
                                        tabindex="-1"
                                    >
                                        {{
                                            ((favorite?.price -
                                                favorite?.discount_price) /
                                                favorite?.price) *
                                                100 | number: "1.0-0"
                                        }}
                                        % 
                                        <span *ngIf="environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL">
                                          {{ "productDetails.off" | translate }}
                                        </span>
                                    </mat-chip>

                                    <mat-chip
                                        *ngIf="favorite?.preorder"
                                        class="chip-item my-1"
                                        tabindex="-1"
                                    >
                                        {{
                                            "productDetails.preorder"
                                                | translate
                                        }}
                                    </mat-chip>

                                    <mat-chip
                                        *ngIf="favorite?.available_soon"
                                        class="chip-item my-1"
                                        tabindex="-1"
                                    >
                                        {{
                                            "productDetails.availableSoon"
                                                | translate
                                        }}
                                    </mat-chip>

                                    <mat-chip
                                        *ngIf="
                                            favorite?.promos?.length &&
                                            favorite?.promos[0]
                                                ?.show_in_product != 0
                                        "
                                        class="chip-item my-1"
                                        tabindex="-1"
                                    >
                                        {{ favorite?.promos[0]?.name }}
                                    </mat-chip>

                                    <mat-chip
                                        *ngIf="
                                            favorite?.promotion &&
                                            !favorite?.direct_discount
                                        "
                                        class="chip-item my-1"
                                        tabindex="-1"
                                    >
                                        {{ favorite?.promotion }}
                                    </mat-chip>

                                    <mat-chip
                                        *ngIf="favorite?.type === 2"
                                        class="chip-item my-1"
                                        tabindex="-1"
                                    >
                                        {{
                                            "productDetails.bundle" | translate
                                        }}
                                    </mat-chip>

                                    <mat-chip
                                        *ngIf="!favorite?.in_stock"
                                        class="chip-item"
                                        tabindex="-1"
                                    >
                                        {{
                                            "home_Page.outOfStouck" | translate
                                        }}
                                    </mat-chip>
                                </div>
                            </div>
                        </div>
                        <div
                            fxFlex.xs="100"
                            fxFlex.sm="100"
                            fxFlex.md="90"
                            fxFlex.lg="80"
                            fxFlex.xl="80"
                        >
                            <div
                                fxLayout="row wrap"
                                fxLayoutAlign="center center"
                                class="cart-product-info"
                            >
                                <div
                                    fxFlex.xs="100"
                                    fxFlex.sm="40"
                                    fxFlex.md="30"
                                    fxFlex.lg="40"
                                    fxFlex.xl="40"
                                >
                                <!-- [queryParams]="{
                                  variant: favorite?.id
                              }" -->
                                    <a
                                        [routerLink]="[
                                            '/' +
                                                lang +
                                                '/' +
                                                favorite.slug
                                        ]"
                                      
                                    >
                                        <h5
                                            style="
                                                cursor: pointer;
                                                outline: none;
                                                margin-bottom: 0px;
                                            "
                                        >
                                            {{ favorite?.name }}
                                        </h5>
                                        <p style="margin-bottom: 0px" *ngIf="environmentVariables?. SHOW_SKU_PRODUCT_DETAILS === true || environmentVariables?. SHOW_SKU_PRODUCT_DETAILS === null">
                                            <span>
                                                {{ "receipt.sku" | translate }}:
                                            </span>
                                            <span class="sku-code">{{
                                                favorite?.sku
                                            }}</span>
                                        </p>
                                        <p style="margin-bottom: 0px" *ngIf="environmentVariables?. SHOW_BARCODE_PRODUCT_DETAILS === true && favorite?.barcode">
                                            <span>
                                                {{ "receipt.barcode" | translate }}:
                                            </span>
                                            <span class="sku-code">{{
                                                favorite?.barcode
                                            }}</span>
                                        </p>
                                    </a>
                                </div>

                                <div
                                    fxFlex.xs="50"
                                    fxFlex.sm="40"
                                    fxFlex.md="30"
                                    fxFlex.lg="20"
                                    fxFlex.xl="20"
                                >
                                    <ng-container>
                                        <button
                                            mat-raised-button
                                            class="blueButton w-150px px-2"
                                            (click)="
                                                redirectToProductFun(favorite)
                                            "
                                            style="
                                                outline: none !important ;
                                                height: 36px;
                                            "
                                        >
                                            <span>
                                                {{
                                                    "productDetails.viewDetails"
                                                        | translate
                                                }}
                                            </span>
                                        </button>
                                        <!-- <app-control-add-to-cart
                                            *ngIf="
                                                favorite?.in_stock &&
                                                favorite?.active &&
                                                !favorite?.soft_deleted
                                            "
                                            [product]="favorite"
                                            [styleCard]="true"
                                            [styleFavorites]="true"
                                            [redirectToProduct]="
                                                redirectToProduct
                                            "
                                        ></app-control-add-to-cart>
                                        <app-cart-stock-validation-errors
                                            [product]="favorite"
                                        ></app-cart-stock-validation-errors> -->
                                    </ng-container>
                                </div>
                                <div
                                    fxFlex.xs="50"
                                    fxFlex.sm="40"
                                    fxFlex.md="30"
                                    fxFlex.lg="20"
                                    fxFlex.xl="20"
                                >
                                    <div
                                        *ngIf="
                                            favorite?.price &&
                                            environmentVariables?.GUEST_CAN_VIEW_PRICES
                                        "
                                        class="cart-item-price"
                                    >
                                        <h4
                                            class="price-value"
                                            [ngClass]="{
                                                'hidden-quantity':
                                                    !favorite?.in_stock ||
                                                    !favorite?.active ||
                                                    favorite?.soft_deleted
                                            }"
                                        >
                                            <br />
                                            <span
                                                style="
                                                    font-size: 13px !important;
                                                "
                                                class="font-bold defult-price-color"
                                                [ngClass]="{
                                                    'config-price-after-discount':
                                                        favorite?.discount_price &&
                                                        environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                                    'config-price-color':
                                                        environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                                    'defult-price-color-after-discount':
                                                        !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                                        favorite?.discount_price,
                                                    'arabic-currency':
                                                        lang == 'ar'
                                                }"
                                            >
                                                {{ favorite?.price | number }}
                                                {{
                                                    lang == "en"
                                                        ? environmentVariables?.CURRENCY_CODE_EN
                                                        : environmentVariables?.CURRENCY_CODE_AR
                                                }}
                                            </span>
                                        </h4>
                                        <h4
                                            class="price-value payment-with-discount-container defult-price-color"
                                            [ngClass]="{
                                                'config-price-before-discount':
                                                    favorite?.discount_price &&
                                                    environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                                'arabic-currency': lang == 'ar',
                                                'hidden-quantity':
                                                    !favorite?.in_stock &&
                                                    !favorite?.active &&
                                                    favorite?.soft_deleted
                                            }"
                                            *ngIf="
                                                favorite?.discount_price &&
                                                environmentVariables?.GUEST_CAN_VIEW_PRICES
                                            "
                                        >
                                            {{
                                                favorite?.discount_price
                                                    | number
                                            }}
                                            {{
                                                lang == "en"
                                                    ? environmentVariables?.CURRENCY_CODE_EN
                                                    : environmentVariables?.CURRENCY_CODE_AR
                                            }}
                                            <div
                                                class="discount-method-information grid-view"
                                                *ngIf="
                                                    favorite?.payment_methods_discount_name_en
                                                "
                                            >
                                                <p>i</p>
                                                <div class="hover-info">
                                                    {{
                                                        lang == "en"
                                                            ? favorite?.payment_methods_discount_name_en
                                                            : favorite?.payment_methods_discount_name_ar
                                                    }}
                                                </div>
                                            </div>
                                        </h4>
                                    </div>
                                </div>
                                <div
                                    class="close-sm"
                                    fxFlex.xs="100"
                                    fxFlex.sm="100"
                                    fxFlex.md="20"
                                    fxFlex.lg="20"
                                    fxFlex.xl="20"
                                >
                                    <div class="cart-item-price">
                                        <a
                                            href="javascript:void(0)"
                                            class="accent-color remove-cart"
                                            (click)="
                                                !favorite['loading']
                                                    ? openConfirmationPopup(
                                                          favorite,
                                                          i
                                                      )
                                                    : null
                                            "
                                        >
                                            <app-loading
                                                *ngIf="favorite['loading']"
                                            ></app-loading>
                                            <mat-icon class="material-icons">
                                                close
                                            </mat-icon>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-container *ngIf="!favoritesList?.length && !loading && !loadingFav">
    <div class="section-gap-lg text-center cartEmpty">
        <div class="mb-4">
            <mat-icon class="material-icons fav-icon"    alt="favorites-empty">
                favorite
            </mat-icon>
        </div>
        <h4>{{ "checkout.favoritesEmpty" | translate }}</h4>
        <a
            href="javascript:void(0)"
            class="primary-color"
            [routerLink]="['/' + lang + '/']"
        >
            {{ "cart.goForShopping" | translate }}</a
        >
    </div>
</ng-container>
